import { Dialog } from "@progress/kendo-react-dialogs";
import { Checkbox } from "@progress/kendo-react-inputs";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import PhoneInputMask from "../../control-components/phone-input-mask/phone-input-mask";
import ZipCodeInput from "../../control-components/zip-code/zip-code";
import ErrorHelper from "../../helper/error-helper";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { clinicService } from "../../services/clinicService";
import ApiUrls from "../../helper/api-urls";
import ApiHelper from "../../helper/api-helper";
import APP_ROUTES from "../../helper/app-routes";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { staffService } from "../../services/staffService";

function AddStaff({ onClose, selectedId }) {
  const naviagte = useNavigate();
  const { state } = useLocation();
  const allClinic = useSelector((state) => state.getAllClinic);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);
  const [domainNameAvailabe, setDomainNameAvailable] = useState(false);
  const [roles, setRoles] = useState([]);
  const [timezones, setTimezones] = useState([]);
  const [gender, setGender] = useState([]);

  let [fields, setFields] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    dob: "",
    email: "",
    masterClinicId: "",
    userName: "",
    phone: "",
    mobile: "",
    genderId: "",
    roleId: "",
    utcDateCreated: "",
    isActive: false,
    isSystemUser: false,
    timeZoneId: "",
  });

  useEffect(() => {
    getRoles();
    getTimezone();
    getGender();
    if (state) {
      getClinicById();
    }
  }, []);

  const getDomainName = (e) => {
    ApiHelper.getRequest(ApiUrls.IS_DUPLICATE_DOMAIN_IN_CLINIC + e)
      .then((result) => {
        setDomainNameAvailable(result.resultData.isDuplicateDomain);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!fields.firstName || fields.firstName.trim().length === 0) {
      formIsValid = false;
      errors["firstName"] = ErrorHelper.FIRST_NAME;
    }

    if (!fields.lastName || fields.lastName.trim().length === 0) {
      formIsValid = false;
      errors["lastName"] = ErrorHelper.LAST_NAME;
    }
    if (!fields.dob) {
      formIsValid = false;
      errors["dob"] = ErrorHelper.DOB;
    }

    if (!emailPattern.test(fields.email)) {
      formIsValid = false;
      errors["email"] = ErrorHelper.INVALID_EMAIL;
    }
    // if (!fields.domainName || fields.domainName.trim().length === 0) {
    //   formIsValid = false;
    //   errors["domainName"] = ErrorHelper.FIELD_BLANK;
    // }
    // else if (domainNameAvailabe) {
    //   formIsValid = false;
    //   errors["domainName"] = ErrorHelper.DOMAIN_NAME;
    // }

    if (!fields.userName) {
      formIsValid = false;
      errors["userName"] = ErrorHelper.USER_NAME;
    }


    if (!fields.masterClinicId) {
      formIsValid = false;
      errors["masterClinicId"] = ErrorHelper.MASTER_CLINIC_ID;
    }

    // if (!fields.clinicName || fields.clinicName.trim().length === 0) {
    //   formIsValid = false;
    //   errors["clinicName"] = ErrorHelper.FIELD_BLANK;
    // }
    if (!fields.phone) {
      formIsValid = false;
      errors["phone"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.mobile) {
      formIsValid = false;
      errors["mobile"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.roleId) {
      formIsValid = false;
      errors["roleId"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.genderId) {
      formIsValid = false;
      errors["genderId"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.utcDateCreated) {
      formIsValid = false;
      errors["utcDateCreated"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.timeZoneId) {
      formIsValid = false;
      errors["timeZoneId"] = ErrorHelper.FIELD_BLANK;
    }




    setErrors(errors);
    return formIsValid;
  };

  const handleCheckboxChange = (e) => {
    const { name, value } = e.target;
    setFields(prevFields => ({
      ...prevFields,
      [name]: !prevFields[name] // Toggle the boolean value
    }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (e.target.name === "userName") {
      setFields({
        ...fields,
        [name]: value,
      });
      if (value.length > 3) {
        getDomainName(value);
      }

    }

    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleValueChange = (e) => {
    const name = e.target.name;
    const rawValue = e.target.rawValue;
    setFields({
      ...fields,
      [name]: rawValue,
    });
  };

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      if (state) {
        updateStaff();
      } else {
        addStaff();
      }
    }
  };

  const getRoles = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.ROLES + 1)
      .then((result) => {
        setLoading(false);
        let roles = result.resultData;
        setRoles(roles);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const getTimezone = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.TIMEZONE + 1)
      .then((result) => {
        setLoading(false);
        let timezones = result.resultData;
        setTimezones(timezones);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const getGender = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.GENDER + 1)
      .then((result) => {
        setLoading(false);
        let genders = result.resultData;
        setGender(genders);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const addStaff = async () => {
    setLoading(true);
    await staffService
      .addStaff(fields)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Add Staff");
        naviagte(APP_ROUTES.STAFF_SEARCH);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const updateStaff = async () => {
    setLoading(true);
    await staffService
      .updateStaff(fields, state)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Update staff");
        naviagte(APP_ROUTES.STAFF_SEARCH);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const getClinicById = async () => {
    setLoading(true);
    await staffService
      .getStaffById(state)
      .then((result) => {
        if (result.resultData) {
          const timezone = {
            id: result.resultData.timeZoneId,
            timeZoneName: result.resultData.timeZoneName,
          };
          const gender = {
            id: result.resultData.genderId,
            name: result.resultData.genderName,
          };

          const masterClinic = {
            id: result.resultData.masterClinicId,
            clinicName: result.resultData.clinicName,
          };

          const role = {
            id: result?.resultData.roleId,
            roleName: result?.resultData?.roleName
          }
          setFields({
            ...fields,
            id: result.resultData.id,
            firstName: result.resultData.firstName,
            lastName: result.resultData.lastName,
            middleName: result.resultData.middleName,
            dob: result?.resultData?.dob && new Date(result?.resultData?.dob),
            email: result.resultData.email,
            masterClinicId: masterClinic,
            address: result.resultData.address,
            city: result.resultData.city,
            state: result.resultData.state,
            zip: result.resultData.zip,
            phone: result.resultData.phone,
            mobile: result.resultData.mobile,
            genderId: gender,
            utcDateCreated:
              result?.resultData?.utcDateAdded &&
              new Date(result?.resultData?.utcDateAdded),
            timeZoneId: timezone,
            userName: result?.resultData?.userName,
            roleId: role,
            isActive:result?.resultData?.isActive,
            isSystemUser:result?.resultData?.isSystemUser,
          });
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleCancel = () => {
    naviagte(APP_ROUTES.STAFF_SEARCH);
  };
  return (
    <>
      <div className="client-accept notenetic-container placeholder-size  align-staff">
        <div className="row">
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <InputKendoRct
              value={fields.firstName}
              onChange={handleChange}
              name="firstName"
              label="First Name"
              error={fields.firstName === "" && errors.firstName}
              validityStyles={settingError}
              required={true}
              className="form-control"
              placeholder={"First Name"}
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <InputKendoRct
              value={fields.lastName}
              onChange={handleChange}
              name="lastName"
              label="Last Name"
              error={fields.lastName === "" && errors.lastName}
              validityStyles={settingError}
              required={true}
              className="form-control"
              placeholder={"Last Name"}
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <InputKendoRct
              value={fields.middleName}
              onChange={handleChange}
              name="middleName"
              label="Middle Name"
              className="form-control"
              placeholder={"Middle Name"}
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12 date-field">
            <DatePickerKendoRct
              validityStyles={settingError}
              onChange={handleChange}
              placeholder="Date of Birth"
              name={"dob"}
              label={"Date of Birth"}
              value={fields.dob}
              error={fields.dob === "" && errors.dob}
              required={true}
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <InputKendoRct
              validityStyles={settingError}
              value={fields.email}
              onChange={handleChange}
              name="email"
              label="Email"
              error={errors.email}
              required={true}
              placeholder="Email"
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12 edit-Service-popup">
            <DropDownKendoRct
              validityStyles={settingError}
              label="Master Clinic Name"
              onChange={handleChange}
              data={allClinic}
              value={fields.masterClinicId}
              textField="clinicName"
              name="masterClinicId"
              error={fields.masterClinicId === "" && errors.masterClinicId}
              required={true}
            />
          </div>
          {state ? (
            " "
          ) : (
            <div className="mb-3 col-lg-4 col-md-6 col-12">
              <InputKendoRct
                type="text"
                validityStyles={settingError}
                value={fields.userName}
                onChange={handleChange}
                name="userName"
                label="User Name"
                error={
                  domainNameAvailabe === true
                    ? ErrorHelper.userName
                    : fields.userName === "" && errors.userName
                }
                required={true}
                placeholder={"User Name"}
                className="form-control fw-2 "
              />
            </div>
          )}
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <PhoneInputMask
              validityStyles={settingError}
              value={fields.phone}
              onChange={handleValueChange}
              name="phone"
              label="Phone"
              error={fields.phone === "" && errors.phone}
              required={true}
              placeholder="Phone"
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <PhoneInputMask
              validityStyles={settingError}
              value={fields.mobile}
              onChange={handleValueChange}
              name="mobile"
              label="Mobile"
              error={fields.mobile === "" && errors.mobile}
              required={true}
              placeholder="mobile"
            />
          </div>
          {state ? (
            ""
          ) : (
            <div className="mb-3 col-lg-4 col-md-6 col-12 edit-Service-popup">
              <DropDownKendoRct
                validityStyles={settingError}
                label="Role"
                onChange={handleChange}
                data={roles}
                value={fields.roleId}
                textField="roleName"
                suggest={true}
                name="roleId"
                error={fields.roleId === "" && errors.roleId}
                required={true}
              />
            </div>
          )}
          <div className="mb-3 col-lg-4 col-md-6 col-12 edit-Service-popup">
            <DropDownKendoRct
              validityStyles={settingError}
              label="Gender"
              onChange={handleChange}
              data={gender}
              value={fields.genderId}
              textField="name"
              suggest={true}
              name="genderId"
              error={fields.genderId === "" && errors.genderId}
              required={true}
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12 date-field">
            <DatePickerKendoRct
              validityStyles={settingError}
              onChange={handleChange}
              placeholder="Date of Birth"
              name={"utcDateCreated"}
              label={"Position Effective Date"}
              value={fields.utcDateCreated}
              error={fields.utcDateCreated === "" && errors.utcDateCreated}
              required={true}
            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12 edit-Service-popup">
            <DropDownKendoRct
              validityStyles={settingError}
              label="TimeZone"
              onChange={handleChange}
              data={timezones}
              value={fields.timeZoneId}
              textField="timeZoneName"
              suggest={true}
              name="timeZoneId"
              error={fields.timeZoneId === "" && errors.timeZoneId}
              required={true}
            />
          </div>
           <div className="mb-3 col-lg-4 col-md-6 col-12 mt-4">
        <div className="d-flex">
          <div className="mr-4">
            <Checkbox
              onChange={handleCheckboxChange}
              label={"Is Active"}
              name="isActive"
              value={fields.isActive}
              checked={fields.isActive}
            />
          </div>
          <div>
            <Checkbox
              onChange={handleCheckboxChange}
              label={"Is System User"}
              name="isSystemUser"
              value={fields.isSystemUser}
              checked={fields.isSystemUser}
            />
          </div>
        </div>
      </div>
        </div>
      </div>
      {loading == true && <Loader />}

      <div className="d-flex my-4 ">
        <button className=" green-btn btn-primary mr-3 btn-space" onClick={handleSubmit}>
          {state ? "Update" : "Add"}
        </button>

        <button className="btn grey-secondary btn-space" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </>
  );
}
export default AddStaff;
